<template>
  <div class="admin-profile-view">
    <div class="admin-profile-header">
      <div class="admin-profile-avatar">
        <span class="admin-profile-initials">{{ getInitials }}</span>
      </div>
      <div class="admin-profile-info">
        <h3 class="admin-profile-name">{{ managerUser?.firstName }} {{ managerUser?.lastName }}</h3>
        <p class="admin-profile-email">{{ managerUser?.email }}</p>
      </div>
    </div>
    <button class="admin-profile-logout-btn" @click="$emit('logout')">
      <i class="fas fa-sign-out-alt"></i>
      <span>Logout</span>
    </button>
  </div>
</template>

<script>
import '../../Admin/styles/AdminProfileView.css';

export default {
  name: 'ClientManagerProfileView',
  props: {
    managerUser: {
      type: Object,
      required: true
    }
  },
  emits: ['logout'],
  computed: {
    getInitials() {
      if (!this.managerUser) return '';
      const firstName = this.managerUser.firstName || '';
      const lastName = this.managerUser.lastName || '';
      const firstInitial = firstName.charAt(0).toUpperCase();
      const lastInitial = lastName.charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    }
  }
}
</script>
